import { BankFeeTab, BottomBar, ExchangeRateTab, OtherTab, PaymentInfoTab } from './tabs';
import { DetailItemTabWrapper } from './DetailItemTabWrapper';
import type { useFormDialog } from './hooks/useFormDialog';

type DialogModel = ReturnType<typeof useFormDialog>;

export const FormTabs = (dialog: DialogModel) =>
  dialog.activeTab === 'info'
    ? [
        {
          id: 'details',
          label: 'Chi tiết',
          component: <DetailItemTabWrapper formMode={dialog.formMode} {...dialog.detail.tableProps} />
        },
        {
          id: 'paymentInfo',
          label: 'Thông tin thanh toán',
          component: <PaymentInfoTab formMode={dialog.formMode} formState={dialog.formState} />
        },
        {
          id: 'exchangeRate',
          label: 'Tỷ giá',
          component: <ExchangeRateTab formMode={dialog.formMode} />
        },
        {
          id: 'bankFee',
          label: 'Phí ngân hàng',
          component: <BankFeeTab formMode={dialog.formMode} {...dialog.bankFee.tableProps} />
        },
        {
          id: 'other',
          label: 'Khác',
          component: <OtherTab formMode={dialog.formMode} rows={dialog.detail.rows} />
        }
      ]
    : [];

export const FormBottomBar = (dialog: DialogModel) => (
  <BottomBar
    tong_tien={dialog.totals.tong_tien}
    tong_thanh_toan={dialog.totals.tong_thanh_toan}
    tong_thue={dialog.totals.tong_thue}
    state={dialog.formState.state}
  />
);
